import React from 'react';

/**
 * **뒤로가기 — 동그란 화살표 하나.**
 *
 * 사이트 곳곳의 뒤로가기가 저마다 다른 모양이었다(글자 길이도 모서리도 색도). 화면마다
 * 다르게 생기면 같은 일을 하는 단추로 안 보이고, 글자를 넣은 판은 좁은 화면에서 넓은 줄을
 * 통째로 차지했다. 그래서 **한 조각으로 모으고 화살표만** 남긴다 — 어느 화면에서나 같은
 * 자리, 같은 크기다.
 *
 * 글자가 없으니 `title`·`aria-label` 로 무엇인지 알린다.
 */

interface Props {
    onClick?: () => void;
    /** 자리·크기를 그 화면에 맞게 덧씌울 때 */
    style?: React.CSSProperties;
    size?: number;
    label?: string;
}

const BackButton: React.FC<Props> = ({ onClick, style, size = 34, label = '뒤로가기' }) => (
    <button
        onClick={onClick}
        title={label}
        aria-label={label}
        style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            width: size,
            height: size,
            borderRadius: '50%',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: Math.round(size * 0.47),
            fontWeight: 700,
            lineHeight: 1,
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
            flexShrink: 0,
            ...style
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
        }}
    >
        {/* 화살표는 글자(←)가 아니라 그림으로 — 글꼴마다 굵기·자리가 달라 가늘고 치우쳐 보였다(사용자) */}
        <svg width={Math.round(size * 0.62)} height={Math.round(size * 0.62)} viewBox="0 0 24 24" fill="none" aria-hidden
            stroke="#fff" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5" />
            <path d="M11 6l-6 6 6 6" />
        </svg>
    </button>
);

export default BackButton;
